'use strict';
define([
    'angular',
    'modules/access/forgot/forgot.controller',
],function(angular, ForgotController){
    var app = angular.module('access.forgot', []);
    app.controller('ForgotController', ForgotController);
    return app;
});